import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod/v4';

const trimUrl = (url: unknown) => (typeof url === 'string' ? url.trim().replace(/\/$/, '') : url);
const url = () => z.preprocess(trimUrl, z.url());
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const bool = () =>
    z.preprocess((val) => {
        if (typeof val === 'string') {
            if (['1', 'true'].includes(val.toLowerCase())) {
                return true;
            }
            if (['0', 'false'].includes(val.toLowerCase())) {
                return false;
            }
        }
        return val;
    }, z.coerce.boolean());

export const env = createEnv({
    server: {
        CMS_API_KEY: z.string(),
        CMS_PREVIEW_KEY: z.string(),
    },
    client: {
        NEXT_PUBLIC_ENV: z.enum(['prod', 'test', 'dev', 'ci']),
        NEXT_PUBLIC_VERSION: z.string().optional(),
        NEXT_PUBLIC_CMS_API_BASE_URL: url(),
        NEXT_PUBLIC_BUILD_CMS_API_BASE_URL: url(),
        NEXT_PUBLIC_SITE_BASE_URL: url(),
    },
    runtimeEnv: {
        CMS_API_KEY: process.env.CMS_API_KEY,
        CMS_PREVIEW_KEY: process.env.CMS_PREVIEW_KEY,
        NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
        NEXT_PUBLIC_VERSION: process.env.NEXT_PUBLIC_VERSION,
        NEXT_PUBLIC_CMS_API_BASE_URL: process.env.NEXT_PUBLIC_CMS_API_BASE_URL,
        NEXT_PUBLIC_BUILD_CMS_API_BASE_URL: process.env.NEXT_PUBLIC_BUILD_CMS_API_BASE_URL,
        NEXT_PUBLIC_SITE_BASE_URL: process.env.NEXT_PUBLIC_SITE_BASE_URL,
    },
    emptyStringAsUndefined: true,
});
